import { VerticalSlug, VerticalUiProfile } from './types'
import { normalizeToVertical } from './normalizeVertical'

export const verticalUiRegistry: Record<VerticalSlug, VerticalUiProfile> = {
  salud: {
    slug: 'salud',
    label: 'Salud y Clínicas',
    terminology: {
      primaryTransactionName: 'Citas y Consultas Médicas',
      primaryTransactionSingular: 'Cita médica',
      primaryTransactionPlural: 'Citas médicas',
      catalogName: 'Servicios y Especialidades',
      itemSingularName: 'Servicio / Consulta',
      itemsPluralName: 'Servicios y Especialidades',
      availabilityLabel: 'Agenda por profesional',
      createItemCta: 'Nuevo Servicio / Consulta',
      emptyCatalogTitle: 'No tienes servicios ni consultas registradas',
      emptyCatalogDescription: 'Registra tus especialidades médicas o estudios para que tus pacientes puedan agendar por WhatsApp.',
      customerRoleLabel: 'Paciente',
      staffRoleLabel: 'Médico / Especialista',
      locationLabel: 'Consultorio o videoconsulta',
      confirmActionLabel: 'Confirmar consulta',
      newTransactionCta: 'Nueva Consulta',
    },
    nav: {
      showOrders: false,
      showAppointments: true,
      primaryTransactionPath: '/app/appointments',
      primaryNavLabel: 'Citas Médicas',
      catalogNavLabel: 'Servicios',
      itemsNavLabel: 'Especialidades',
    },
    operational: {
      hasFulfillment: false,
      hasAppointmentsCalendar: true,
    },
    dashboard: {
      sectionTitle: 'Gestión de Consultas y Citas Médicas',
      sectionBadge: 'Agendamiento Asistido',
      kpis: [
        {
          id: 'salud-consultas-total',
          title: 'Consultas agendadas',
          unit: 'citas',
          description: 'Solicitudes anotadas por el bot y registradas',
          icon: 'calendar',
          colorScheme: 'teal',
          dataKey: 'totalAppointments',
          format: 'number',
        },
        {
          id: 'salud-consultas-pending',
          title: 'Pendientes de confirmar',
          unit: 'solicitudes',
          description: 'Esperan confirmación manual del personal',
          badgeLabel: 'Manual',
          icon: 'clock',
          colorScheme: 'amber',
          dataKey: 'pendingAppointments',
          format: 'number',
        },
        {
          id: 'salud-consultas-confirmed',
          title: 'Consultas confirmadas',
          unit: 'confirmadas',
          description: 'Validadas y agendadas con médico asignado',
          icon: 'check-circle',
          colorScheme: 'emerald',
          dataKey: 'confirmedAppointments',
          format: 'number',
        },
      ],
    },
  },

  inmobiliaria: {
    slug: 'inmobiliaria',
    label: 'Bienes Raíces e Inmobiliaria',
    terminology: {
      primaryTransactionName: 'Visitas a Inmuebles',
      primaryTransactionSingular: 'Visita',
      primaryTransactionPlural: 'Visitas',
      catalogName: 'Cartera de Inmuebles',
      itemSingularName: 'Inmueble',
      itemsPluralName: 'Inmuebles',
      availabilityLabel: 'Disponible / Reservado / Alquilado',
      createItemCta: 'Nuevo Inmueble',
      emptyCatalogTitle: 'No tienes inmuebles en cartera',
      emptyCatalogDescription: 'Registra apartamentos, casas o locales para coordinar visitas guiadas con tus clientes.',
      customerRoleLabel: 'Interesado / Visitante',
      staffRoleLabel: 'Asesor inmobiliario',
      locationLabel: 'Dirección del inmueble o punto de encuentro',
      confirmActionLabel: 'Confirmar visita',
      newTransactionCta: 'Nueva Visita',
    },
    nav: {
      showOrders: false,
      showAppointments: true,
      primaryTransactionPath: '/app/appointments',
      primaryNavLabel: 'Visitas Agendadas',
      catalogNavLabel: 'Cartera de Inmuebles',
      itemsNavLabel: 'Inmuebles',
    },
    operational: {
      hasFulfillment: false,
      hasAppointmentsCalendar: true,
    },
    dashboard: {
      sectionTitle: 'Gestión de Visitas y Cartera Inmobiliaria',
      sectionBadge: 'Inmobiliario',
      kpis: [
        {
          id: 'inmo-visitas-total',
          title: 'Visitas agendadas',
          unit: 'visitas',
          description: 'Visitas a propiedades coordinadas con clientes',
          icon: 'calendar',
          colorScheme: 'indigo',
          dataKey: 'totalAppointments',
          format: 'number',
        },
        {
          id: 'inmo-visitas-pending',
          title: 'Visitas por confirmar',
          unit: 'solicitudes',
          description: 'Solicitudes que requieren validación del asesor',
          badgeLabel: 'Por validar',
          icon: 'clock',
          colorScheme: 'amber',
          dataKey: 'pendingAppointments',
          format: 'number',
        },
        {
          id: 'inmo-cartera-activa',
          title: 'Inmuebles en cartera',
          unit: 'propiedades',
          description: 'Propiedades activas disponibles para visita',
          icon: 'home',
          colorScheme: 'blue',
          dataKey: 'activeProducts',
          format: 'number',
        },
      ],
    },
  },

  belleza_estetica: {
    slug: 'belleza_estetica',
    label: 'Belleza y Estética',
    terminology: {
      primaryTransactionName: 'Citas y Turnos',
      primaryTransactionSingular: 'Cita / Turno',
      primaryTransactionPlural: 'Citas y Turnos',
      catalogName: 'Servicios y Tratamientos',
      itemSingularName: 'Servicio',
      itemsPluralName: 'Servicios y Tratamientos',
      availabilityLabel: 'Agenda por estilista',
      createItemCta: 'Nuevo Servicio',
      emptyCatalogTitle: 'No tienes tratamientos registrados',
      emptyCatalogDescription: 'Agrega servicios de peluquería, manicura, barbería o spa para coordinar reservas por WhatsApp.',
      customerRoleLabel: 'Cliente',
      staffRoleLabel: 'Estilista / Profesional',
      locationLabel: 'Puesto, cabina o sucursal',
      confirmActionLabel: 'Confirmar turno',
      newTransactionCta: 'Nuevo Turno',
    },
    nav: {
      showOrders: false,
      showAppointments: true,
      primaryTransactionPath: '/app/appointments',
      primaryNavLabel: 'Turnos y Citas',
      catalogNavLabel: 'Tratamientos',
      itemsNavLabel: 'Servicios',
    },
    operational: {
      hasFulfillment: false,
      hasAppointmentsCalendar: true,
    },
    dashboard: {
      sectionTitle: 'Gestión de Turnos y Tratamientos',
      sectionBadge: 'Estética & Turnos',
      kpis: [
        {
          id: 'belleza-turnos-total',
          title: 'Turnos solicitados',
          unit: 'turnos',
          description: 'Citas de estilismo o estética anotadas',
          icon: 'calendar',
          colorScheme: 'rose',
          dataKey: 'totalAppointments',
          format: 'number',
        },
        {
          id: 'belleza-turnos-pending',
          title: 'Turnos por confirmar',
          unit: 'solicitudes',
          description: 'Citas a confirmar por el personal tras abono',
          badgeLabel: 'Por confirmar',
          icon: 'clock',
          colorScheme: 'amber',
          dataKey: 'pendingAppointments',
          format: 'number',
        },
        {
          id: 'belleza-servicios-activos',
          title: 'Servicios en carta',
          unit: 'servicios',
          description: 'Tratamientos y servicios activos ofrecidos',
          icon: 'heart',
          colorScheme: 'purple',
          dataKey: 'activeProducts',
          format: 'number',
        },
      ],
    },
  },

  turismo_posadas: {
    slug: 'turismo_posadas',
    label: 'Turismo y Posadas',
    terminology: {
      primaryTransactionName: 'Reservas y Estadías',
      primaryTransactionSingular: 'Reserva',
      primaryTransactionPlural: 'Reservas',
      catalogName: 'Habitaciones y Planes',
      itemSingularName: 'Habitación / Plan',
      itemsPluralName: 'Habitaciones y Planes',
      availabilityLabel: 'Fechas y cupos',
      createItemCta: 'Nueva Habitación o Plan',
      emptyCatalogTitle: 'No tienes habitaciones ni planes registrados',
      emptyCatalogDescription: 'Crea habitaciones, posadas o paquetes turísticos para que tus huéspedes soliciten reservas.',
      customerRoleLabel: 'Huésped',
      staffRoleLabel: 'Anfitrión / Encargado',
      locationLabel: 'Habitación, cabaña o posada',
      confirmActionLabel: 'Confirmar reserva',
      newTransactionCta: 'Nueva Reserva',
    },
    nav: {
      showOrders: false,
      showAppointments: true,
      primaryTransactionPath: '/app/appointments',
      primaryNavLabel: 'Reservas',
      catalogNavLabel: 'Hospedaje',
      itemsNavLabel: 'Habitaciones y Planes',
    },
    operational: {
      hasFulfillment: false,
      hasAppointmentsCalendar: true,
    },
    dashboard: {
      sectionTitle: 'Rendimiento de Reservas y Estadías',
      sectionBadge: 'Reservas & Posadas',
      kpis: [
        {
          id: 'turismo-reservas-total',
          title: 'Reservas registradas',
          unit: 'reservas',
          description: 'Solicitudes de alojamiento o planes turísticos',
          icon: 'bed',
          colorScheme: 'teal',
          dataKey: 'totalAppointments',
          format: 'number',
        },
        {
          id: 'turismo-reservas-pending',
          title: 'Pendientes de abono',
          unit: 'solicitudes',
          description: 'Reservas en espera de comprobante o validación',
          badgeLabel: 'Abono 50%',
          icon: 'clock',
          colorScheme: 'amber',
          dataKey: 'pendingAppointments',
          format: 'number',
        },
        {
          id: 'turismo-planes-activos',
          title: 'Planes y posadas',
          unit: 'opciones',
          description: 'Paquetes turísticos y habitaciones activas',
          icon: 'building',
          colorScheme: 'purple',
          dataKey: 'activeProducts',
          format: 'number',
        },
      ],
    },
  },

  servicios: {
    slug: 'servicios',
    label: 'Servicios Profesionales',
    terminology: {
      primaryTransactionName: 'Citas y Asesorías',
      primaryTransactionSingular: 'Cita',
      primaryTransactionPlural: 'Citas',
      catalogName: 'Servicios y Planes',
      itemSingularName: 'Servicio',
      itemsPluralName: 'Servicios y Planes',
      availabilityLabel: 'Agenda',
      createItemCta: 'Nuevo Servicio',
      emptyCatalogTitle: 'No tienes servicios registrados',
      emptyCatalogDescription: 'Registra tus servicios profesionales, asesorías o consultorías para que tus clientes agenden contigo.',
      customerRoleLabel: 'Cliente',
      staffRoleLabel: 'Profesional / Consultor',
      locationLabel: 'Oficina, dirección o enlace virtual',
      confirmActionLabel: 'Confirmar cita',
      newTransactionCta: 'Nueva Cita',
    },
    nav: {
      showOrders: false,
      showAppointments: true,
      primaryTransactionPath: '/app/appointments',
      primaryNavLabel: 'Citas y Asesorías',
      catalogNavLabel: 'Servicios',
      itemsNavLabel: 'Planes y Servicios',
    },
    operational: {
      hasFulfillment: false,
      hasAppointmentsCalendar: true,
    },
    dashboard: {
      sectionTitle: 'Asesorías y Citas de Servicio',
      sectionBadge: 'Servicios Profesionales',
      kpis: [
        {
          id: 'serv-citas-total',
          title: 'Citas y asesorías',
          unit: 'citas',
          description: 'Solicitudes de asesoría agendadas por clientes',
          icon: 'calendar',
          colorScheme: 'teal',
          dataKey: 'totalAppointments',
          format: 'number',
        },
        {
          id: 'serv-citas-pending',
          title: 'Pendientes de confirmar',
          unit: 'solicitudes',
          description: 'Reuniones pendientes de validación por asesor',
          badgeLabel: 'Manual',
          icon: 'clock',
          colorScheme: 'amber',
          dataKey: 'pendingAppointments',
          format: 'number',
        },
        {
          id: 'serv-servicios-activos',
          title: 'Servicios activos',
          unit: 'servicios',
          description: 'Paquetes de asesoría y servicios ofertados',
          icon: 'briefcase',
          colorScheme: 'indigo',
          dataKey: 'activeProducts',
          format: 'number',
        },
      ],
    },
  },

  restaurante: {
    slug: 'restaurante',
    label: 'Restaurante y Gastronomía',
    terminology: {
      primaryTransactionName: 'Comandas y Pedidos',
      primaryTransactionSingular: 'Comanda / Pedido',
      primaryTransactionPlural: 'Comandas y Pedidos',
      catalogName: 'Menú y Carta',
      itemSingularName: 'Plato / Combo',
      itemsPluralName: 'Platos y Combos',
      availabilityLabel: 'Activo / Agotado hoy',
      createItemCta: 'Nuevo Plato / Combo',
      emptyCatalogTitle: 'No tienes platos ni combos en tu carta',
      emptyCatalogDescription: 'Agrega tus especialidades culinarias, combos y bebidas para tomar pedidos por WhatsApp.',
      customerRoleLabel: 'Comensal / Cliente',
      staffRoleLabel: 'Mesero / Encargado',
      locationLabel: 'Mesa o dirección de entrega',
      confirmActionLabel: 'Confirmar pedido',
      newTransactionCta: 'Nueva Comanda',
    },
    nav: {
      showOrders: true,
      showAppointments: false,
      primaryTransactionPath: '/app/orders',
      primaryNavLabel: 'Comandas y Pedidos',
      catalogNavLabel: 'Menú',
      itemsNavLabel: 'Platos y Combos',
    },
    operational: {
      hasFulfillment: true,
      hasAppointmentsCalendar: false,
      deliveryFilterEnabled: true,
    },
    dashboard: {
      sectionTitle: 'Rendimiento de Comandas y Despacho',
      sectionBadge: 'Delivery & Salón',
      kpis: [
        {
          id: 'rest-comandas-total',
          title: 'Comandas tomadas',
          unit: 'pedidos',
          description: 'Pedidos confirmados con platos del menú',
          icon: 'shopping-cart',
          colorScheme: 'emerald',
          dataKey: 'totalCarts',
          format: 'number',
        },
        {
          id: 'rest-ventas-total',
          title: 'Total comandado',
          unit: '$',
          description: 'Valor acumulado de comandas de delivery y retiro',
          badgeLabel: 'Tasa BCV',
          icon: 'dollar',
          colorScheme: 'blue',
          dataKey: 'totalQuotedAmount',
          format: 'currency',
        },
        {
          id: 'rest-autonomia',
          title: 'Efectividad autónoma',
          unit: '%',
          description: 'Comandas tomadas sin intervención del personal',
          icon: 'zap',
          colorScheme: 'purple',
          dataKey: 'autonomousResolutionRate',
          format: 'percent',
        },
      ],
    },
  },

  tienda_repuestos: {
    slug: 'tienda_repuestos',
    label: 'Tienda de Repuestos y Autopartes',
    terminology: {
      primaryTransactionName: 'Órdenes y Envíos',
      primaryTransactionSingular: 'Orden',
      primaryTransactionPlural: 'Órdenes',
      catalogName: 'Repuestos',
      itemSingularName: 'Repuesto',
      itemsPluralName: 'Repuestos y Autopartes',
      availabilityLabel: 'Stock disponible',
      createItemCta: 'Nuevo Repuesto',
      emptyCatalogTitle: 'No tienes repuestos registrados',
      emptyCatalogDescription: 'Registra piezas, repuestos OEM y reemplazos con marca y modelo para despachar pedidos.',
      customerRoleLabel: 'Cliente',
      staffRoleLabel: 'Asesor de repuestos',
      locationLabel: 'Dirección de envío o mostrador',
      confirmActionLabel: 'Confirmar orden',
      newTransactionCta: 'Nueva Orden',
    },
    nav: {
      showOrders: true,
      showAppointments: false,
      primaryTransactionPath: '/app/orders',
      primaryNavLabel: 'Órdenes',
      catalogNavLabel: 'Inventario',
      itemsNavLabel: 'Repuestos',
    },
    operational: {
      hasFulfillment: true,
      hasAppointmentsCalendar: false,
    },
    dashboard: {
      sectionTitle: 'Rendimiento de Cotizaciones de Mostrador',
      sectionBadge: 'Mostrador Repuestos',
      kpis: [
        {
          id: 'rep-carritos-total',
          title: 'Carritos armados',
          unit: 'pedidos',
          description: 'Cotizaciones con repuesto confirmado y cerrado',
          icon: 'shopping-cart',
          colorScheme: 'emerald',
          dataKey: 'totalCarts',
          format: 'number',
        },
        {
          id: 'rep-monto-total',
          title: 'Monto total cotizado',
          unit: '$',
          description: 'Valor de repuestos cotizados y pedidos cerrados',
          icon: 'dollar',
          colorScheme: 'blue',
          dataKey: 'totalQuotedAmount',
          format: 'currency',
        },
        {
          id: 'rep-catalogo-activo',
          title: 'Repuestos en catálogo',
          unit: 'artículos',
          description: 'Autopartes y repuestos activos para el bot',
          icon: 'wrench',
          colorScheme: 'amber',
          dataKey: 'activeProducts',
          format: 'number',
        },
      ],
    },
  },

  bodegon_licoreria: {
    slug: 'bodegon_licoreria',
    label: 'Bodegón y Licorería',
    terminology: {
      primaryTransactionName: 'Pedidos y Entregas',
      primaryTransactionSingular: 'Pedido',
      primaryTransactionPlural: 'Pedidos',
      catalogName: 'Licores y Productos',
      itemSingularName: 'Producto / Licor',
      itemsPluralName: 'Licores y Snacks',
      availabilityLabel: 'Stock disponible',
      createItemCta: 'Nuevo Producto',
      emptyCatalogTitle: 'No tienes productos registrados',
      emptyCatalogDescription: 'Publica licores, bebidas frías y snacks para despachos express nocturnos.',
      customerRoleLabel: 'Cliente',
      staffRoleLabel: 'Despachador',
      locationLabel: 'Dirección de entrega',
      confirmActionLabel: 'Confirmar pedido',
      newTransactionCta: 'Nuevo Pedido',
    },
    nav: {
      showOrders: true,
      showAppointments: false,
      primaryTransactionPath: '/app/orders',
      primaryNavLabel: 'Pedidos',
      catalogNavLabel: 'Bodegón',
      itemsNavLabel: 'Licores y Productos',
    },
    operational: {
      hasFulfillment: true,
      hasAppointmentsCalendar: false,
    },
    dashboard: {
      sectionTitle: 'Ventas Express y Delivery Nocturno',
      sectionBadge: 'Delivery Express',
      kpis: [
        {
          id: 'bode-pedidos-total',
          title: 'Pedidos tomados',
          unit: 'pedidos',
          description: 'Combos y productos pedidos por WhatsApp',
          icon: 'shopping-cart',
          colorScheme: 'emerald',
          dataKey: 'totalCarts',
          format: 'number',
        },
        {
          id: 'bode-ventas-total',
          title: 'Ventas estimadas',
          unit: '$',
          description: 'Monto de carritos confirmados en divisas',
          icon: 'dollar',
          colorScheme: 'blue',
          dataKey: 'totalQuotedAmount',
          format: 'currency',
        },
        {
          id: 'bode-autonomia',
          title: 'Efectividad autónoma',
          unit: '%',
          description: 'Ventas cerradas sin transferir a un asesor',
          icon: 'zap',
          colorScheme: 'purple',
          dataKey: 'autonomousResolutionRate',
          format: 'percent',
        },
      ],
    },
  },

  ferreteria: {
    slug: 'ferreteria',
    label: 'Ferretería y Materiales',
    terminology: {
      primaryTransactionName: 'Cotizaciones y Órdenes',
      primaryTransactionSingular: 'Cotización / Orden',
      primaryTransactionPlural: 'Cotizaciones y Órdenes',
      catalogName: 'Materiales y Herramientas',
      itemSingularName: 'Material / Herramienta',
      itemsPluralName: 'Materiales y Herramientas',
      availabilityLabel: 'Stock por unidad de medida',
      createItemCta: 'Nuevo Material',
      emptyCatalogTitle: 'No tienes materiales registrados',
      emptyCatalogDescription: 'Registra cemento, cables, pinturas y herramientas por unidad de medida para cotizaciones y despacho.',
      customerRoleLabel: 'Cliente / Contratista',
      staffRoleLabel: 'Asesor técnico',
      locationLabel: 'Dirección de obra o sucursal',
      confirmActionLabel: 'Confirmar cotización',
      newTransactionCta: 'Nueva Cotización',
    },
    nav: {
      showOrders: true,
      showAppointments: false,
      primaryTransactionPath: '/app/orders',
      primaryNavLabel: 'Cotizaciones y Órdenes',
      catalogNavLabel: 'Inventario',
      itemsNavLabel: 'Materiales',
    },
    operational: {
      hasFulfillment: true,
      hasAppointmentsCalendar: false,
    },
    dashboard: {
      sectionTitle: 'Cotizaciones y Ventas de Mostrador',
      sectionBadge: 'Mostrador & Obra',
      kpis: [
        {
          id: 'ferr-cotizaciones-total',
          title: 'Cotizaciones generadas',
          unit: 'órdenes',
          description: 'Presupuestos cerrados de materiales y herramientas',
          icon: 'shopping-cart',
          colorScheme: 'emerald',
          dataKey: 'totalCarts',
          format: 'number',
        },
        {
          id: 'ferr-monto-total',
          title: 'Monto cotizado',
          unit: '$',
          description: 'Volumen total de presupuestos cerrados',
          icon: 'dollar',
          colorScheme: 'blue',
          dataKey: 'totalQuotedAmount',
          format: 'currency',
        },
        {
          id: 'ferr-articulos-activos',
          title: 'Artículos en inventario',
          unit: 'ítems',
          description: 'Materiales y artículos activos en catálogo',
          icon: 'wrench',
          colorScheme: 'blue',
          dataKey: 'activeProducts',
          format: 'number',
        },
      ],
    },
  },

  tecnologia: {
    slug: 'tecnologia',
    label: 'Tecnología y Retail',
    terminology: {
      primaryTransactionName: 'Órdenes y Ventas',
      primaryTransactionSingular: 'Orden',
      primaryTransactionPlural: 'Órdenes',
      catalogName: 'Catálogo de Tecnología',
      itemSingularName: 'Producto',
      itemsPluralName: 'Equipos y Productos',
      availabilityLabel: 'Stock disponible',
      createItemCta: 'Nuevo Producto',
      emptyCatalogTitle: 'No tienes productos de tecnología registrados',
      emptyCatalogDescription: 'Agrega equipos, teléfonos, accesorios y gadgets a tu catálogo.',
      customerRoleLabel: 'Cliente',
      staffRoleLabel: 'Asesor de ventas',
      locationLabel: 'Dirección de envío o tienda',
      confirmActionLabel: 'Confirmar orden',
      newTransactionCta: 'Nueva Orden',
    },
    nav: {
      showOrders: true,
      showAppointments: false,
      primaryTransactionPath: '/app/orders',
      primaryNavLabel: 'Órdenes',
      catalogNavLabel: 'Catálogo',
      itemsNavLabel: 'Equipos y Productos',
    },
    operational: {
      hasFulfillment: true,
      hasAppointmentsCalendar: false,
    },
    dashboard: {
      sectionTitle: 'Rendimiento Comercial y Ventas Tech',
      sectionBadge: 'Tech Retail',
      kpis: [
        {
          id: 'tech-pedidos-total',
          title: 'Pedidos de equipos',
          unit: 'pedidos',
          description: 'Dispositivos y accesorios en checkout',
          icon: 'shopping-cart',
          colorScheme: 'emerald',
          dataKey: 'totalCarts',
          format: 'number',
        },
        {
          id: 'tech-monto-total',
          title: 'Monto cotizado',
          unit: '$',
          description: 'Valor acumulado de carritos tecnológicos',
          icon: 'dollar',
          colorScheme: 'blue',
          dataKey: 'totalQuotedAmount',
          format: 'currency',
        },
        {
          id: 'tech-autonomia',
          title: 'Efectividad autónoma',
          unit: '%',
          description: 'Ventas cerradas automáticamente por el bot',
          icon: 'zap',
          colorScheme: 'purple',
          dataKey: 'autonomousResolutionRate',
          format: 'percent',
        },
      ],
    },
  },

  educacion: {
    slug: 'educacion',
    label: 'Educación y Cursos',
    terminology: {
      primaryTransactionName: 'Inscripciones y Citas',
      primaryTransactionSingular: 'Inscripción',
      primaryTransactionPlural: 'Inscripciones',
      catalogName: 'Cursos y Programas',
      itemSingularName: 'Curso / Programa',
      itemsPluralName: 'Cursos y Talleres',
      availabilityLabel: 'Cupos disponibles',
      createItemCta: 'Nuevo Curso',
      emptyCatalogTitle: 'No tienes cursos registrados',
      emptyCatalogDescription: 'Registra tus cursos, talleres o diplomados para gestionar inscripciones.',
      customerRoleLabel: 'Estudiante / Representante',
      staffRoleLabel: 'Coordinador / Instructor',
      locationLabel: 'Aula o enlace de clase virtual',
      confirmActionLabel: 'Confirmar inscripción',
      newTransactionCta: 'Nueva Inscripción',
    },
    nav: {
      showOrders: true,
      showAppointments: true,
      primaryTransactionPath: '/app/orders',
      primaryNavLabel: 'Inscripciones',
      catalogNavLabel: 'Academia',
      itemsNavLabel: 'Cursos',
    },
    operational: {
      hasFulfillment: false,
      hasAppointmentsCalendar: true,
    },
    dashboard: {
      sectionTitle: 'Entrevistas y Citas de Admisión',
      sectionBadge: 'Admisiones & Cursos',
      kpis: [
        {
          id: 'edu-entrevistas-total',
          title: 'Entrevistas solicitadas',
          unit: 'citas',
          description: 'Citas de asesoría vocacional y admisión agendadas',
          icon: 'calendar',
          colorScheme: 'indigo',
          dataKey: 'totalAppointments',
          format: 'number',
        },
        {
          id: 'edu-entrevistas-pending',
          title: 'Por coordinar',
          unit: 'solicitudes',
          description: 'Aspirantes en espera de asignación de horario',
          icon: 'clock',
          colorScheme: 'amber',
          dataKey: 'pendingAppointments',
          format: 'number',
        },
        {
          id: 'edu-programas-activos',
          title: 'Cursos y programas',
          unit: 'programas',
          description: 'Cursos, diplomados o programas activos',
          icon: 'graduation-cap',
          colorScheme: 'blue',
          dataKey: 'activeProducts',
          format: 'number',
        },
      ],
    },
  },

  tienda: {
    slug: 'tienda',
    label: 'Tienda y Comercio',
    terminology: {
      primaryTransactionName: 'Órdenes y Pedidos',
      primaryTransactionSingular: 'Orden',
      primaryTransactionPlural: 'Órdenes',
      catalogName: 'Catálogo',
      itemSingularName: 'Producto',
      itemsPluralName: 'Productos',
      availabilityLabel: 'Stock',
      createItemCta: 'Nuevo Producto',
      emptyCatalogTitle: 'No tienes productos en tu catálogo',
      emptyCatalogDescription: 'Agrega productos para que tus clientes puedan comprar por WhatsApp.',
      customerRoleLabel: 'Cliente',
      staffRoleLabel: 'Asesor de ventas',
      locationLabel: 'Dirección de entrega',
      confirmActionLabel: 'Confirmar orden',
      newTransactionCta: 'Nueva Orden',
    },
    nav: {
      showOrders: true,
      showAppointments: false,
      primaryTransactionPath: '/app/orders',
      primaryNavLabel: 'Órdenes',
      catalogNavLabel: 'Catálogo',
      itemsNavLabel: 'Productos',
    },
    operational: {
      hasFulfillment: true,
      hasAppointmentsCalendar: false,
    },
    dashboard: {
      sectionTitle: 'Rendimiento Comercial del Agente',
      sectionBadge: 'Funnel WhatsApp',
      kpis: [
        {
          id: 'tienda-carritos-total',
          title: 'Carritos armados',
          unit: 'pedidos',
          description: 'Llegaron a checkout con producto confirmado',
          icon: 'shopping-cart',
          colorScheme: 'emerald',
          dataKey: 'totalCarts',
          format: 'number',
        },
        {
          id: 'tienda-monto-total',
          title: 'Monto total cotizado',
          unit: '$',
          description: 'Valor acumulado de carritos y compras',
          icon: 'dollar',
          colorScheme: 'blue',
          dataKey: 'totalQuotedAmount',
          format: 'currency',
        },
        {
          id: 'tienda-autonomia',
          title: 'Efectividad autónoma',
          unit: '%',
          description: 'Atendidas sin necesidad de escalamiento humano',
          icon: 'zap',
          colorScheme: 'purple',
          dataKey: 'autonomousResolutionRate',
          format: 'percent',
        },
      ],
    },
  },

  otro: {
    slug: 'otro',
    label: 'Comercio General',
    terminology: {
      primaryTransactionName: 'Órdenes y Pedidos',
      primaryTransactionSingular: 'Orden',
      primaryTransactionPlural: 'Órdenes',
      catalogName: 'Catálogo',
      itemSingularName: 'Producto',
      itemsPluralName: 'Productos',
      availabilityLabel: 'Stock',
      createItemCta: 'Nuevo Producto',
      emptyCatalogTitle: 'No tienes productos en tu catálogo',
      emptyCatalogDescription: 'Agrega productos para que tus clientes puedan comprar por WhatsApp.',
      customerRoleLabel: 'Cliente',
      staffRoleLabel: 'Atención al cliente',
      locationLabel: 'Dirección o sucursal',
      confirmActionLabel: 'Confirmar orden',
      newTransactionCta: 'Nueva Orden',
    },
    nav: {
      showOrders: true,
      showAppointments: true,
      primaryTransactionPath: '/app/orders',
      primaryNavLabel: 'Órdenes',
      catalogNavLabel: 'Catálogo',
      itemsNavLabel: 'Productos',
    },
    operational: {
      hasFulfillment: true,
      hasAppointmentsCalendar: false,
    },
    dashboard: {
      sectionTitle: 'Rendimiento Comercial del Agente',
      sectionBadge: 'Funnel LangGraph',
      kpis: [
        {
          id: 'gen-carritos-total',
          title: 'Carritos armados',
          unit: 'pedidos',
          description: 'Llegaron a checkout con producto confirmado',
          badgeLabel: 'WhatsApp',
          icon: 'shopping-cart',
          colorScheme: 'emerald',
          dataKey: 'totalCarts',
          format: 'number',
        },
        {
          id: 'gen-monto-total',
          title: 'Monto total cotizado',
          unit: '$',
          description: 'Valor acumulado de carritos y cotizaciones',
          badgeLabel: 'Cotizado',
          icon: 'dollar',
          colorScheme: 'blue',
          dataKey: 'totalQuotedAmount',
          format: 'currency',
        },
        {
          id: 'gen-autonomia',
          title: 'Efectividad autónoma',
          unit: '%',
          description: 'Atendidas sin necesidad de escalamiento humano',
          badgeLabel: 'Autonomía',
          icon: 'zap',
          colorScheme: 'purple',
          dataKey: 'autonomousResolutionRate',
          format: 'percent',
        },
      ],
    },
  },
}

export const GENERIC_VERTICAL_PROFILE = verticalUiRegistry.otro

export function getVerticalProfile(slug: VerticalSlug): VerticalUiProfile {
  return verticalUiRegistry[slug] || GENERIC_VERTICAL_PROFILE
}

/**
 * Resuelve la ruta inicial tras login según el vertical del tenant.
 * Respeta fromPath si el usuario intentaba acceder a una ruta protegida específica.
 */
export function resolvePostLoginDestination(
  businessType: string | null | undefined,
  fromPath?: string | null
): string {
  if (fromPath) return fromPath
  const vertical = normalizeToVertical(businessType)
  const profile = getVerticalProfile(vertical)
  return profile.nav.showAppointments && !profile.nav.showOrders
    ? '/app/appointments'
    : '/app/dashboard'
}

